<div class="row">
  <div class="col-md-12 text-center">
    <div class="text-orange"><b>&nbsp;{{message}}..</b></div>
  </div>
</div>
<div class="row w-75 mx-auto">
  <div class="col-md-12">
    <p-progressBar mode="indeterminate"></p-progressBar>
  </div>
</div>
